import axios from "axios";
import _ from "lodash";

const formatMessage = (intl, message, options) => {
  return intl.formatMessage({ id: message }, options);
};
const fetcher = async (url, suffix, setState) => {
  let _state = [];
  const requestOptions = {
    method: "GET",
    redirect: "follow",
    headers: {
      Accept: "application/ld+json",
      Authorization: "Bearer " + localStorage.getItem("TOKEN_BEARER"),
      // 'Content-Type': 'application/x-www-form-urlencoded',
    },
  };

  fetch(url + suffix, requestOptions)
    .then((response) => response.json())
    .then((result) => {
      result = result["hydra:member"];
      if (result.length === 0) {
        //   setNoBESC(true);
      }

      for (let res of result) {
        _state.push(res);
      }

      setState(_state);
    })
    .catch((e) => {
      console.log("an error occured, details : ", e);
    });
};

const add = async (
  url,
  suffix,
  mode,
  value,
  setValue,
  feedback,
  setFeedback,
  enqueueSnackbar,
  closeSnackbar
) => {
  let _return = null;

  let _message = mode === "add" ? "Ajout en cours..." : "Modification en cours";

  setFeedback({ ...feedback, ["bdOpen"]: true });
  let sb = notify(_message, "info", "center", "bottom", false, enqueueSnackbar);

  let config = {
    method: mode === "add" ? "post" : "put",
    maxBodyLength: Infinity,
    url: mode === "add" ? url + suffix : url + suffix + "/" + value.id,
    headers:
      mode === "add"
        ? {
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("TOKEN_BEARER"),
          }
        : {
            "Content-Type": "application/ld+json",
            Authorization: "Bearer " + localStorage.getItem("TOKEN_BEARER"),
          },
    data: value,
  };

  return axios
    .request(config)
    .then((response) => {
      console.log("sucess!! response below :");

      _return = response.data;

      console.log(response.data);

      blank(value, setValue);
      setFeedback({ ...feedback, ["bdOpen"]: false });
      closeSnack(sb, closeSnackbar);
      notify(
        mode === "add"
          ? "Ajout effectué avec succès"
          : "Modification effectuée avec succès",
        "success",
        "center",
        "top",
        true,
        enqueueSnackbar
      );

      document.body.style.opacity = 1;
    })
    .catch((error) => {
      console.log("error!! error below :");
      console.log(error);
      setFeedback({ ...feedback, ["bdOpen"]: false });
      closeSnack(sb, closeSnackbar);
      notify(
        error.response.data["title"] + ", " + error.response.data["detail"],
        "error",
        "center",
        "top",
        true,
        enqueueSnackbar
      );
      // setLoading(false);
      // setOpen(false);
      document.body.style.opacity = 1;
      _return = error;
    });
};

const del = async (
  _index,
  url,
  suffix,
  feedback,
  setFeedback,
  enqueueSnackbar,
  closeSnackbar
) => {
  let config = {
    method: "delete",
    maxBodyLength: Infinity,
    url: url + suffix + "/" + _index,
    headers: {
      "Content-Type": "*/*",
      Authorization: "Bearer " + localStorage.getItem("TOKEN_BEARER"),
    },
  };

  setFeedback({ ...feedback, ["bdOpen"]: true });
  let sb = notify(
    "Suprression en cours",
    "info",
    "center",
    "bottom",
    false,
    enqueueSnackbar
  );
  axios
    .request(config)
    .then((response) => {
      console.log("sucess!! response below :");
      console.log(response.data);

      setFeedback({ ...feedback, ["bdOpen"]: false });
      closeSnack(sb, closeSnackbar);
      notify(
        "Suppression effectuée avec succès",
        "success",
        "center",
        "top",
        true,
        enqueueSnackbar
      );

      document.body.style.opacity = 1;
    })
    .catch((error) => {
      console.log("error!! error below :");
      console.log(error);
      // setLoading(false);
      // setOpen(false);
      setFeedback({ ...feedback, ["bdOpen"]: false });
      closeSnack(sb, closeSnackbar);
      notify(
        error.response.data["hydra:title"] +
          ", " +
          error.response.data["hydra:description"],
        "error",
        "center",
        "top",
        true,
        enqueueSnackbar
      );
      document.body.style.opacity = 1;
    });
};

const getTag = (besc) => {
  if (besc.redressement) {
    return "R";
  }
  if (besc.isRegul) {
    return besc.exoneration ? "XO" : "RG";
  }
};

const blank = (value, setValue) => {
  let _value = { ...value };
  console.log("temp value before blank : ", _value);
  for (let k in _value) {
    console.log("key to blank : ", k);
    _value[k] = "";
  }
  if (_value.translations) {
    delete _value.translations;
  }
  _value.description_en = "";
  _value.description_fr = "";
  console.log("new value : ", _value);
  setValue(_value);
};

const notify = (
  message,
  type,
  horizontal = true,
  vertical = false,
  autohide = true,
  func
) => {
  return func(message, {
    anchorOrigin: {
      horizontal: horizontal,
      vertical: vertical,
    },
    autoHideDuration: autohide ? 3000 : null,
    variant: type,
  });
};

const closeSnack = (id, func) => {
  func(id);
};

const debounceLoad = _.debounce(async (api, search, suffix, setter) => {
  try {
    const response = await fetch(props.api + suffix + search, requestOptions);
    //await sleep(1e3); // For demo purposes.
    let _shippers = await response.json();
    _shippers = _shippers["hydra:member"];

    let options = [];
    for (let s of _shippers) {
      options.push(s);
    }
    setter(options);
  } catch {
    (e) => {
      console.log("an error occured, details : ", e);
    };
  }
}, 600);

const formatDate = (date) => {
  let ss = date.substring(0, 10);
  ss = ss.split("-")[2] + "/" + ss.split("-")[1] + "/" + ss.split("-")[0];
  let sss = date.substring(11, 19);
  return ss;
};

const formatError = (error) => {
  console.log("type of error : ", error.name);
  if (error.name === "AxiosError") {
    console.log("this is an axios error");
    console.log("reponse : ", error.response);
    console.log("isEmpty error response : ", _.isEmpty(error.reponse));
    if (error.response && Object.keys(error.response).length > 0) {
      if (error.response.data.detail) {
        console.log("detail and title present");
        if (error.response.data.title && error.response.data.detail) {
          return error.response.data.title + " " + error.response.data.detail;
        } else {
          return error.response.data.detail;
        }
      }
      if (
        error.response.data["hydra:title"] &&
        error.response.data["hydra:detail"]
      ) {
        return (
          error.response.data["hydra:title"] +
          error.response.data["hydra:detail"]
        );
      }

      if (error.response.data.message) {
        return error.response.data.message;
      }
    } else {
      console.log("no reponse but message");
      return error.message ? error.message : "Erreur Inconnue";
    }
  } else {
    return error.message ? error.message : "Erreur Inconnue";
  }
};

const sendNotification = (
  sender,
  recipients,
  message,
  feedback,
  setFeedback,
  enqueueSnackbar,
  closeSnackbar
) => {
  console.log(
    "called sendNotification with params : ",
    sender,
    recipients,
    message
  );
  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: "https://security.besc.cncc.cm/api/send-notification",
    headers: { "Content-Type": "application/json" },
    data: {
      destination_users: recipients,
      origin_user: sender,
      message: message.content,
      data: {
        subject: message.subject,
        priority: 1,
        flag: 0,
        action: 0,
      },
    },
  };

  setFeedback({ ...feedback, ["bdOpen"]: true });
  let sb = notify(
    "Envoi de la notification en cours",
    "info",
    "center",
    "bottom",
    false,
    enqueueSnackbar
  );

  axios
    .request(config)
    .then((response) => {
      console.log("sucess!! response below :");
      console.log(response.data);

      setFeedback({ ...feedback, ["bdOpen"]: false });
      closeSnack(sb, closeSnackbar);
      notify(
        "Notification envoyée avec succès",
        "success",
        "center",
        "top",
        true,
        enqueueSnackbar
      );
    })
    .catch((error) => {
      console.log("error!! error below :");
      console.log(error);
      setFeedback({ ...feedback, ["bdOpen"]: false });
      closeSnack(sb, closeSnackbar);
      notify(error, "error", "center", "top", true, enqueueSnackbar);
      document.body.style.opacity = 1;
    });
};

export {
  fetcher,
  add,
  del,
  blank,
  notify,
  closeSnack,
  formatDate,
  debounceLoad,
  sendNotification,
  formatError,
  formatMessage,
  getTag,
};
